<template>
  <g
    @click="$emit('click')"
    :class="{
      'cursor-grab': draggable,
    }"
  >
    <component
      :is="location.component_type"
      :location="location"
      :strokeColour="strokeColour"
      :fillColour="fillColour"
      :textColour="textColour"
      :className="className"
      :textClassName="textClassName"
      :isDragging="isDragging"
      :pointsString="pointsString"
    />
  </g>
</template>
<script setup>
import { computed } from 'vue';

defineEmits(['click']);

const props = defineProps({
  location: {
    type: Object,
    default: () => ({}),
  },
  overrideStrokeColour: {
    type: String,
    default: '',
  },
  overrideFillColour: {
    type: String,
    default: '',
  },
  overrideTextColour: {
    type: String,
    default: '',
  },
  defaultPalette: {
    type: Object,
    default: () => ({}),
  },
  draggable: {
    type: Boolean,
    default: false,
  },
  isDragging: {
    type: Boolean,
    default: false,
  },
  className: {
    type: String,
    default: '',
  },
  textClassName: {
    type: String,
    default: '',
  },
});

const pointsString = computed(() => (props.location.is_polygon ? props.location.points.map((p) => p.join(',')).join(' ') : ''));

const strokeColour = computed(() => {
  if (props.overrideStrokeColour) {
    return props.overrideStrokeColour;
  }
  if (props.location.border_colour) {
    return props.location.border_colour;
  }
  return props.defaultPalette[`${props.location.palette_key}_border_colour`];
});

const fillColour = computed(() => {
  if (props.overrideFillColour) {
    return props.overrideFillColour;
  }
  if (props.location.fill_colour) {
    return props.location.fill_colour;
  }
  return props.defaultPalette[`${props.location.palette_key}_fill_colour`];
});

const textColour = computed(() => {
  if (props.overrideTextColour) {
    return props.overrideTextColour;
  }
  if (props.location.text_colour) {
    return props.location.text_colour;
  }
  return props.defaultPalette[`${props.location.palette_key}_text_colour`];
});
</script>
